import type { IntegrationKey } from 'entities/Integrations'
import type { IContactAll } from 'entities/Contacts'
import type { Message } from 'entities/Message/model/Message'
import type { Conversation } from 'entities/Conversation'
import type { IParamsContactsSearch } from 'entities/Contacts/api/types'
import type { IParamsSearchMessages } from 'entities/Message'

export type TContactsPaginationSnapshot = Pick<
  IParamsContactsSearch,
  'per_page' | 'page' | 'skip_opted_out' | 'term'
>

export type TMessagesPaginationSnapshot = Pick<IParamsSearchMessages, 'per_page' | 'page' | 'term'>

export type TContactsByIntegrationSnapshot = {
  items: IContactAll[]
  total: number
  pagination: TContactsPaginationSnapshot
}

export type TResultsContactsSnapshot = {
  activeIntegrationTab: IntegrationKey
  topResults: IContactAll[]
  integrations: Partial<Record<IntegrationKey, TContactsByIntegrationSnapshot>>
}

export type TResultsMessagesSnapshot = {
  total: number
  pagination: TMessagesPaginationSnapshot
  messagesAll: Message[]
  conversationsById: Array<[number, Conversation]>
}

export type TSearchResultsSessionCacheState = {
  search: string
  contacts: TResultsContactsSnapshot
  messages: TResultsMessagesSnapshot
}

let _state: TSearchResultsSessionCacheState | null = null

export const getSearchResultsSessionCache = (
  search: string
): TSearchResultsSessionCacheState | null => {
  if (!_state) return null
  if (_state.search !== search) return null
  return _state
}

export const setSearchResultsSessionCache = (state: TSearchResultsSessionCacheState) => {
  _state = state
}

export const clearSearchResultsSessionCache = () => {
  _state = null
}
